import { Component } from '@angular/core';

@Component({
  selector: 'pfp-root',
  template: `<router-outlet></router-outlet>`,
})
export class AppComponent {
  title = 'pfp';
}
